import { render, staticRenderFns } from "./DynamicFromNow.vue?vue&type=template&id=be01fa18&scoped=true&"
import script from "./DynamicFromNow.vue?vue&type=script&lang=js&"
export * from "./DynamicFromNow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be01fa18",
  null
  
)

export default component.exports